module.exports = __webpack_public_path__ + "static/display_short-a95a7625bb2c69263f6efb7cf3ad3c04.gif";